import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getLocale, getLocaleDayOfWeek, isDayOfWeek } from '@infl-ts/util-date';
import { useLanguage } from '@infl-ts/util-i18n-provider';
import { Box, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, Typography } from '@mui/material';
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import { useCallback } from 'react';
import { Translation, useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";

var isValidOptionSelected = function isValidOptionSelected(selected, options) {
  return options.some(function (_ref) {
    var value = _ref.value;
    return value === selected;
  });
};

var isOnlyDailyAvailable = function isOnlyDailyAvailable(options) {
  return options.length === 1 && options[0].value === 'daily';
};

var translateLabel = function translateLabel(t, locale) {
  return function (label) {
    return pipe(label, function (s) {
      return s.split(', ');
    }, A.map(function (s) {
      return isDayOfWeek(s) ? getLocaleDayOfWeek(s, locale) : t(s);
    }), function (s) {
      return s.join(', ');
    });
  };
};

var DeliverySelector = function DeliverySelector(_ref2) {
  var _digestDeliveryOption, _digestDeliveryOption2;

  var preferences = _ref2.preferences,
      setPreferences = _ref2.setPreferences,
      disabled = _ref2.disabled,
      digestDeliveryOptions = _ref2.digestDeliveryOptions,
      setDirty = _ref2.setDirty;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang;

  var translate = translateLabel(t, getLocale(currentLang));
  var onChange = useCallback(function (event) {
    setDirty();
    setPreferences(_objectSpread(_objectSpread({}, preferences), {}, {
      emailDigestDeliveryDays: event.target.value
    }));
  }, [setDirty, setPreferences, preferences]);
  var value = isValidOptionSelected(preferences.emailDigestDeliveryDays, digestDeliveryOptions) ? preferences.emailDigestDeliveryDays : (_digestDeliveryOption = (_digestDeliveryOption2 = digestDeliveryOptions[0]) === null || _digestDeliveryOption2 === void 0 ? void 0 : _digestDeliveryOption2.value) !== null && _digestDeliveryOption !== void 0 ? _digestDeliveryOption : 'daily';
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      ml: 4
    },
    "data-element": "Box",
    "data-component": "DeliverySelector",
    "data-source-file": "digest-delivery-selector.tsx",
    children: isOnlyDailyAvailable(digestDeliveryOptions) ? /*#__PURE__*/_jsx(Typography, {
      variant: "subtitle2",
      children: /*#__PURE__*/_jsx(Translation, {
        children: function children(t) {
          return t('You will receive the Challenge Digest on a daily basis.');
        }
      })
    }) : /*#__PURE__*/_jsx(FormControl, {
      children: digestDeliveryOptions.length === 2 && digestDeliveryOptions.some(function (_ref3) {
        var value = _ref3.value;
        return value === 'weekdays';
      }) ? /*#__PURE__*/_jsx(RadioGroup, {
        value: value,
        onChange: onChange,
        children: digestDeliveryOptions.map(function (_ref4, index) {
          var label = _ref4.label,
              value = _ref4.value;
          return /*#__PURE__*/_jsx(FormControlLabel, {
            value: value,
            label: translate(label),
            control: /*#__PURE__*/_jsx(Radio, {})
          }, index);
        })
      }) : /*#__PURE__*/_jsx(Select, {
        size: "small",
        sx: {
          minWidth: 250
        },
        value: value,
        disabled: disabled,
        onChange: onChange,
        children: digestDeliveryOptions.map(function (_ref5) {
          var label = _ref5.label,
              value = _ref5.value;
          return /*#__PURE__*/_jsx(MenuItem, {
            value: value,
            children: translate(label)
          }, value);
        })
      })
    })
  });
};

export default DeliverySelector;